import { render, staticRenderFns } from "./DrawerMenuArea.vue?vue&type=template&id=6bbaa529&lang=pug"
import script from "./DrawerMenuArea.vue?vue&type=script&lang=js"
export * from "./DrawerMenuArea.vue?vue&type=script&lang=js"
import style0 from "./DrawerMenuArea.vue?vue&type=style&index=0&id=6bbaa529&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports